import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableDescriptionCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={sharedModule.description} />
    </TableSimpleCell>
  );
};

export default SharedModulesTableDescriptionCell;
